import React from 'react'

const Remittance = () => {
  return (
    <div>Remittance</div>
  )
}

export default Remittance